import React from 'react'

export default function HomeContent() {
  return (
    <section className="container">
    </section>
  )
}
